import React, { Component } from 'react';

import SweetAlert from 'react-bootstrap-sweetalert';
// koneksi
import { Get } from '../function/Koneksi';
import ModalSuratAhliWaris from '../feature/modal/ahli-waris-pandau';

const frmDex = {
	uuid: '',
	id_jenis: '',
	nik_pelapor: '',
	nik: '',
	kk: '',
	nama: '',
	tempat_lahir: '',
	tanggal_lahir: '',
	jenis_kelamin: '',
	pekerjaan: '',
	pendidikan_terakhir: '',
	kewarganegaraan: '',
	agama: '',
	alamat: '',
	status_perkawinan: "",
	waktu_meninggal: "",
	tempat_meninggal: "",
	tgl_dikebumikan: "",
	
	nik2: '',
	nama2: '',
	tempat_lahir2: '',
	tanggal_lahir2: '',
	jenis_kelamin2: '',
	pekerjaan2: '',
	pendidikan_terakhir2: '',
	kewarganegaraan2: '',
	agama2: '',
	alamat2: '',
	status_perkawinan2: "",
	waktu_meninggal2: "",
	tempat_meninggal2: "",
	tgl_dikebumikan2: "",
	detail: [],
  
	nik_ahli_waris: "",
	nama_ahli_waris: "",
	jk_ahli_waris: "",
	tempat_lahir_ahli_waris: "",
	pekerjaan_ahli_waris: "",
	shdk_ahli_waris: "",
	tgl_lahir_ahli_waris: new Date()
}


export default class SuratIzinKeramainan extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: {
				form: false,
				btnForm: false,
				btnAksi: [],
				dataPelapor: "none",
				dataPenduduk: "none",
				dataPenduduk2: "none",
				ahliWarisManual: "none",
			},

			dt: frmDex,
			tmplistPenduduk: null,
			// Form Data 
			frmPkr: [],
			pkrStat: [],
			frmAgm: [],
			agmStat: [],
			frmNik: [],
			nikStat: null,
			nikStatMeninggal: null,
			frmNik2: [],
			nik2Stat: null,
			frmNik3: [],
			nik3Stat: null,
			frmShdk: [],
			shdk_aw: null,

			waktu_meninggal: new Date(),
			waktu_meninggal2: new Date(),

			formAhliWaris : "none",
      		meninggal: "none",
		  	meninggal2: "none",

			// keyboard
			layoutName: 'default',
			inputName: '',
			input: {},
			inputPattern: /^\d+$/,
			display: 'block',
			focus: false,
			hasFocus: false,

			Basic: false,
			longContent: false,
			Vertically: false,
			Tooltips: false,
			Grid: false,
			VaryingMdo: false,
			VaryingFat: false,
			VaryingBootstrap: false,
			sizeLarge: false,
			sizeSmall: false,

			alert: null,
			show: false,
			basicTitle: '',
			basicType: 'default',
			pesanAlert: '',
			successAlert: false,
			isDown: false,
			startY: null,
			scrollUp: null,

			
			// Pilih Data Keluarga
			frmNikKeluarga: [],
			nikStatTerlapor: null,
			dt_keluarga:[],
			dataKeluarga: "none",
		};
		this.showKeyboard = this.showKeyboard.bind(this);
		this.onChangeInput = this.onChangeInput.bind(this);
	}

	handleShift = () => {
		const layoutName = this.state.layoutName;

		this.setState({
			layoutName: layoutName === 'default' ? 'shift' : 'default'
		});
	};

	onChangeAll = (inputObj) => {
		let updatedInputObj = {
			...this.state.input,
			[this.state.inputName]: inputObj[this.state.inputName]
		};
		this.setState({
			// input: inputObj
			input: updatedInputObj
		});
	};

	setActiveInput = (inputName) => {
		this.setState(
			{
				inputName: inputName
			},
			() => {
				//console.log('Active input', inputName);
			}
		);
	};

	onChangeInput = (event) => {
		let inputVal = event.target.value;

		let updatedInputObj = {
			...this.state.input,
			[this.state.inputName]: inputVal
		};

		//console.log(inputVal);
		//console.log(updatedInputObj);

		this.setState(
			{
				input: updatedInputObj
			},
			() => {
				if (typeof this.keyboard != 'undefined') {
					this.keyboard.setInput(inputVal);
				}
			}
		);
	};

	onKeyPress = (button) => {
		// //console.log('Button pressed', button);

		if (button === '{shift}' || button === '{lock}') {
			this.handleShift();
		}
	};

	showKeyboard = () => {
		if (!this.state.focus || this.state.display) {
			this.setState({
				focus: true,
				display: ''
			});
		}
		this.forceUpdate();
	};

	onOpenModal = (key) => {
		this.setState({ [key]: true });
	};

	onCloseModal = (key) => {
		this.setState({ 
			[key]: false, 
			dt_keluarga:{
				nik: '',
				kk: '',
				nama: '',
				agama: '',
				alamat: '',
				jenis_kelamin: '',
				pekerjaan: '',
				status_perkawinan: '',
				tanggal_lahir: '',
				tempat_lahir: '',
				pendidikan_terakhir: '',
			},
			dataKeluarga:'none',
			nikStatTerlapor:null,
		});
	};

	handleClick = (event) => {
		alert(event);
	};
	
	componentDidMount() {
		// Get list anggota keluarga from parent
		if (this.props.anggotaKeluarga) {
			this.setState({ frmNikKeluarga: this.props.anggotaKeluarga })
			this.setState({ 
				frmNik: this.props.anggotaKeluarga,
				tmplistPenduduk: this.props.tmplistPenduduk,
			})
		}

		if (this.props.data.results.data_kk == null) {
			// Jika data keluarga null
			let tmplistPenduduk = []
			let frmNik3 = [];
			this.props.data.results.data_kk_pend_temp.data_keluarga.forEach((dt) => {
				frmNik3.push({ value: dt.id, label: dt.id });
				tmplistPenduduk = {
					...tmplistPenduduk,
					[dt.id]: dt
				}
			});
			this.setState({
				frmNik2: frmNik3,
				frmNik3: frmNik3,
				tmplistPenduduk,
			})
			this.forceUpdate();
		} else {
			// Data Keluarga Tidak Null
			// Get list anggota keluarga from parent
			if (this.props.anggotaKeluarga) {
				let tmplistPenduduk = {}
				let frmNik3 = [];
				this.props.anggotaKeluarga.forEach((dt) => {
					frmNik3.push({ value: dt.id, label: dt.id });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.value]: dt
					}
				});
				this.setState({
					frmNik2: this.props.anggotaKeluarga,
					frmNik3: this.props.anggotaKeluarga,
					tmplistPenduduk,
				})
			}
		}

		Get('shdk/list', null, data => {
			let frmShdk = [];
			data.results.forEach(dt => {
				frmShdk.push({ value: dt.uuid, label: dt.nama });
			});
			this.setState({ frmShdk });
		});
		
		Get("pekerjaan/list", null, data => {
			let frmPkr = [];
			data.results.forEach(dt => {
				frmPkr.push({ value: dt.uuid, label: dt.nama });
			});
			this.setState({ frmPkr });
		});

		Get("agama/list", null, data => {
			let frmAgm = [];
			data.results.forEach(dt => {
				frmAgm.push({ value: dt.uuid, label: dt.nama });
			});
			this.setState({ frmAgm });
		});
	}

	handleInputChangeNIK = (e, fld) => {
		if (e) {
			if (fld === "nikTerlapor") {
				let newArray = this.state.frmNikKeluarga;
	
				newArray = newArray.filter(day => day !== e);

				this.setState({
					frmNikKeluarga:newArray,
				})
			}
		}
	};

	render() {


		const styleImgIcon = {
			height: '42,58px',
			width: '65,83px'
		};


		return (
			<div>
				<SweetAlert
					show={this.state.show}
					// show={true}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					cancelBtnBsStyle="info"
					onCancel={this.closeAlert}
					showConfirm={false}
				/>

				<ModalSuratAhliWaris
					data={this.state.dt}
					isOpen={this.state.status.form}
					propsData={this.props}
					kiosk={true}
					optionData={{
						frmNik: this.state.frmNik,
						frmNik2: this.state.frmNik2,
						frmNik3: this.state.frmNik3,
						frmShdk: this.state.frmShdk,
						// optShdk: this.state.optShdk,
						nikStat: this.state.nikStat,
						nikStatMeninggal: this.state.nikStatMeninggal,
						nik2Stat: this.state.nik2Stat,
						frmPkr: this.state.frmPkr,
						status: this.state.status,
						meninggal: this.state.meninggal,
						meninggal2: this.state.meninggal2,
						formAhliWaris: this.state.formAhliWaris
					}}
					getAntrian={(jenis_surat, status, uncomplete, data) =>
						this.props.getAntrian(jenis_surat, status, uncomplete, data)}
					setAlert={(e) => {
						this.setState(e)
					}}
					setIsOpen={(e) => {
						if (!e) {
							this.setState({ dt: null })
						}
						this.setState({
							status: {
								...this.state.status,
								form: e
							}
						})
					}}
				/>
			
				<div
					className="card kiosk-card"
					// onClick={() => this.onOpenModal(`Basic`)}
					onClick={(e) => {
						if (!e) {
							this.setState({ dt: null })
						}
						this.props.getJenisSuratCard('Surat Keterangan Ahli Waris Pandau')
						this.setState({
							status: {
								...this.state.status,
								form: e
							}
						})
					}}
					style={{
						marginTop: '20px',
						marginBottom: '20px',
						marginLeft: '10px',
						marginRight: '10px',
						height: '170px',
						minWidth: 'max-content',
						borderRadius: '20px'
					}}
				>
					<div className="card-body">
						<div
							className="row"
							style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}
						>
							{
								this.props.detailSurat && this.props.detailSurat.icon_kiosk
								?
									<img
										src={this.props.detailSurat.icon_kiosk}
										alt="logo"
										height="65"
										style={styleImgIcon}
									/>
								:
									<img 
										src={require("../assets/images/tes-loading.gif")} 
										alt="loading"
										style={{
											height: '70px',
										}}
									/> 
							}
						</div>
						<div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
							<p
								className="mb-0"
								style={{
									fontSize: '20px',
									fontWeight: '600',
									color: '#000000'
								}}
							>
								Ahli Waris
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
